import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $dragged?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${cbSemanticCssVars.borderPrimary};
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  overflow: hidden;
  cursor: grab;
  transition: opacity 150ms;

  ${({ $dragged }) =>
    $dragged
      ? css`
          opacity: 0.3;
          transform: scale(0.5, 0.5);
        `
      : css`
          &:hover {
            opacity: 0.8;
          }
        `}
`;

export const Frame = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const Name = styled.span`
  ${typographyCss.Overline3()}
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  flex-shrink: 0;
  padding: 8px 12px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  outline: 1px solid ${cbSemanticCssVars.borderPrimary};
`;
